import * as React from 'react';
import { Title as TitleComponent } from '../../components/Title';

interface ITitleProps {
  title?: string | null;
}

export function Title({ title }: ITitleProps) {
  if (!title) {
    return null;
  }

  return <TitleComponent title={title} />;
}
